import toast, { Toast } from 'react-hot-toast'
import { CheckCheck } from 'lucide-react'
import { Button } from '@/src/renderer/components/ui/Button'
import type { SuccessToastOptions } from './SuccessToast.types'
import './SuccessToast.scss'

export function showSuccessToast({ message, duration = 5000, action }: SuccessToastOptions) {
  return toast.custom(
    (t: Toast) => (
      <div
        className={`success-toast ${t.visible ? 'success-toast--visible' : 'success-toast--hidden'}`}
      >
        <CheckCheck size={18} className="success-toast__icon" />
        <span className="success-toast__message">{message}</span>
        {action && (
          <Button
            variant="outline"
            size="small"
            onClick={async () => {
              toast.dismiss(t.id)
              await action.onClick()
            }}
          >
            {action.label}
          </Button>
        )}
      </div>
    ),
    { duration }
  )
}
